import { Button } from 'lib/button';
import styled from 'styled-components';

const ToastButton = styled(Button)`
  margin-left: ${({ theme }) => theme.size.spacing.medium.value};
`;

export { ToastButton };
